export default __webpack_public_path__ + "static/media/studies_img_two.1884ba8e.jpg";